import React from 'react';
import ResourceTypes from './ResourceTypes';
import { ModuleProps } from 'types';
import getRoutes from './routes';
import RouteModuleFactory from '../@layout/Router/RouteModuleFactory';

const routes = getRoutes();

const ResourcesModule: React.FC<ModuleProps> = moduleProps => {
  return <RouteModuleFactory IndexComponent={ResourceTypes} routes={routes} {...moduleProps} />;
};

export default ResourcesModule;
